// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { post } from "./operations.js";
export type { ResolvePrivateLinkServiceIdPostOptionalParams } from "./options.js";
